export default "__VITE_ASSET__bf3e02b4__"